import { defineMessages } from "react-intl";

export const messages = defineMessages({
	status: {
		id: "kd.patient_list.status",
		defaultMessage: "Státusz"
	},
	name: {
		id: "kd.patient_list.name",
		defaultMessage: "Név"
	},
	socialSecurityNumber: {
		id: "kd.patient_list.social_security_number",
		defaultMessage: "TAJ szám"
	},

	ageLabel: {
		id: "kd.patient_list.age",
		defaultMessage: "Életkor"
	},
	ageUnit: {
		id: "kd.patient_list.age_unit",
		defaultMessage: "éves"
	},
	sex: {
		id: "kd.patient_list.sex",
		defaultMessage: "Nem"
	},
	city: {
		id: "kd.patient_list.city",
		defaultMessage: "Város"
	},
	weight: {
		id: "kd.patient_list.weight",
		defaultMessage: "Súly"
	},
	bloodGroup: {
		id: "kd.patient_list.bloodGroup",
		defaultMessage: "Vércsoport"
	},

	waitingListLabel: {
		id: "kd.patient_list.waiting_list_label",
		defaultMessage: "ET várólistán"
	},
	waitingListDaysUnitDesktop: {
		id: "kd.patient_list.waiting_list_days_unit_desktop",
		defaultMessage: "napja"
	},
	waitingListMonthsUnitDesktop: {
		id: "kd.patient_list.waiting_list_months_unit_desktop",
		defaultMessage: "hónapja"
	},
	waitingListDaysUnitMobile: {
		id: "kd.patient_list.waiting_list_days_unit_mobile",
		defaultMessage: "napja várólistán"
	},
	waitingListMonthsUnitMobile: {
		id: "kd.patient_list.waiting_list_months_unit_mobile",
		defaultMessage: "hónapja várólistán"
	},
	statusByNephrologist: {
		id: "kd.patient_list.status_by_nephrologist",
		defaultMessage: "Nefrológus véleménye"
	},
	modifTime: {
		id: "kd.patient_list.modif_time",
		defaultMessage: "Utolsó módosítás"
	}
});
